export default function Head() {
  return (
    <>
      <meta content="width=device-width, initial-scale=1" name="viewport" />
      <meta
        name="description"
        content="I'm Abdul Munim, full-stack Mobile developer and Web Developer based in Islamabad, Pakistan. My journey in mobile development began during my bachelors."
      />
      <meta
        name="keywords"
        content="Abdul Munim, portfolio, Abdul, Munim, Abdul Munim,, full stack dev, nextjs portfolio, portfolio design, portfolio website, personal portfolio, mobile, mobile app, app, mobile developer, mobile app developer, flutter, flutter developer, best flutter developer"
      />
      <meta property="og:site_name" content="Abdul Munim's Portfolio" />
      <meta
        property="og:title"
        content="Portfolio | Abdul Munim - Mobile & Web Developer"
      />
      <meta
        property="og:description"
        content="I'm Abdul Munim, full-stack mobile developer based in Islamabad, Pakistan. My journey in mobile development began during my bachelors."
      />
      <meta name="author" content="Abdul Munim" />
      <meta name="language" content="English" />
      <meta name="twitter:card" content="summary" />

      <meta
        name="application-name"
        content="Portfolio | Abdul Munim - Mobile & Web Developer"
      />
      <meta
        name="apple-mobile-web-app-title"
        content="Portfolio | Abdul Munim - Mobile & Web Developer"
      />
      <link rel="icon" href="/favicon.ico" />
      <meta name="viewport" content="initial-scale=1.0, width=device-width" />

      <title>Portfolio | Abdul Munim - Mobile & Web Developer</title>
    </>
  );
}
